import Env from '../base/env'
import Cookies from 'js-cookie'

export default class PopinAlert
{
    constructor()
    {
        this.$popin = document.getElementById('jsPopin--alert')
        this.$triggers = document.querySelectorAll('.jsTrigger--popinAlert')
        this.$receptor = this.$popin.querySelector('.popin__content')
        this.$btnClose = this.$popin.querySelector('.jsClose')
        this.$btnCloseOverlay = this.$popin.querySelector('.jsCloseOverlay')

        // Flags
        this.ENABLED = false
        // Fns
        this.events()
    }

    alert()
    {
        if(typeof Cookies.get('moodletter_popin_2022_new') == 'undefined' &&  typeof Cookies.get('moodletter_subscription') == 'undefined') {
            this.open()
        }
        Cookies.set('moodletter_popin_2022_new', '1', { expires: 0.5 });
    }

    events()
    {
        this.$btnClose.addEventListener('click',()=>{
            this.close()
        })
        this.$btnCloseOverlay.addEventListener('click',()=>{
            this.close()
        })
        for(let i = 0; i < this.$triggers.length; i++) {
            const $trigger = this.$triggers[i]
            $trigger.addEventListener('click',()=>{
                this.open()
            })
        }

    }

    close()
    {
        if(this.ENABLED) {
            this.transitionClose()
        }
    }

    open()
    {
        if(this.ENABLED == false) {
            this.transitionOpen()
        }
    }

    reset()
    {
        this.ENABLED = false
    }

    transitionClose(fnComplete='')
    {
        let timeline = new TimelineLite()
        const dimensions = this.$receptor.getBoundingClientRect()

        this.ENABLED = false

        timeline.add([
            TweenLite.to(this.$btnClose, .4 , { scale : 0 , ease : Cubic.easeInOut }),
            TweenLite.fromTo(this.$receptor , .5 , { clip : `rect(0px,${dimensions.width}px,${dimensions.height}px,0px)` } , { clip : `rect(0px,${dimensions.width / 2}px,${dimensions.height}px,${dimensions.width / 2}px)` , ease : Power3.easeInOut , delay : .2 }),
        ])
        timeline.add(()=>{
            this.$popin.classList.remove('is--active')
            Env.$html.classList.remove('popin--isOpened')
            this.$btnClose.removeAttribute('style')
            this.$receptor.removeAttribute('style')
            this.reset()
            if(typeof fnComplete != 'undefined' && typeof fnComplete == 'function') {
                fnComplete()
            }
        })
    }

    transitionOpen()
    {
        let timeline = new TimelineLite({ delay : .3 })
        const dimensions = this.$receptor.getBoundingClientRect()

        this.$popin.classList.add('is--active')
        Env.$html.classList.add('popin--isOpened')
        this.ENABLED = true

        timeline.add([
            TweenLite.fromTo(this.$receptor , .5 , { clip : `rect(0px,${dimensions.width / 2}px,${dimensions.height}px,${dimensions.width / 2}px)` } , { clip : `rect(0px,${dimensions.width}px,${dimensions.height}px,0px)` , ease : Power3.easeOut }),
            TweenLite.fromTo(this.$btnClose, .4 , {  scale : 0 } , { scale : 1 , ease : Cubic.easeOut , delay : .15 }),
        ])
        timeline.add(()=>{
            TweenLite.set(this.$receptor , { clearProps : 'clip' })
            if(typeof fnComplete != 'undefined' && typeof fnComplete == 'function') {
                fnComplete()
            }
        })
    }
}